module.exports = __webpack_public_path__ + "images/help_icon.png";